/**
 * Directive: navExpanded
 */
angular.module('acme.common.directive.navExpanded', [])
.directive('navExpanded', [function() {

    return {
      restrict: 'A',
      link: function($scope, $element, $attrs, $ctrl) {
        $scope.$on('$destroy', $scope.$watch('item.toggle', function(n,o) {

          var hiddens = [];
          if ($scope.item.items) {
            $scope.item.items.filter(function(subItem) {
              return subItem.hidden;
            });
          }

          if ($scope.item.items && $scope.item.items.length > hiddens.length) {
            $element.attr('aria-expanded', $scope.item.toggle);
          }
        }));
      }
    };

}]);
